export default "__VITE_ASSET__D95HBCBF__"